import { AbstractProps } from 'types/common/PropsTypes';

const FramePageInner = ({ children }: AbstractProps) => {
  return <div className="page-inner p-none no-border">{children}</div>;
};

export default FramePageInner;
